import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { fmtDateDay } from "@/lib/dates";
import { Users, Pencil, Trash2 } from "lucide-react";

const byName = (a, b) => `${a.last_name} ${a.first_name}`.localeCompare(`${b.last_name} ${b.first_name}`);

export const AttendeesDialog = ({ session, members, onClose, onEdit, onDelete }) => {
  const ids = session?.present_member_ids || [];
  const list = members.filter((m) => ids.includes(m.id)).sort(byName);
  return (
    <Dialog open={!!session} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-white max-w-md max-h-[85vh] overflow-y-auto" data-testid="attendees-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{session?.title}</DialogTitle>
          <p className="text-sm text-[#7A8A78]">{session?.service_type} · {fmtDateDay(session?.date)}</p>
          <p className="flex items-center gap-1.5 text-sm font-medium text-[#2D5A27]" data-testid="attendees-count">
            <Users className="h-4 w-4" /> {list.length} attended
          </p>
        </DialogHeader>
        <ul className="divide-y divide-[#E5E0D8] border border-[#E5E0D8] rounded-xl">
          {list.map((m) => (
            <li key={m.id} className="flex items-center gap-3 px-4 py-2.5" data-testid={`attendee-row-${m.id}`}>
              <div className="h-8 w-8 shrink-0 rounded-full flex items-center justify-center text-white text-xs font-semibold"
                style={{ backgroundColor: m.avatar_color || "#2D5A27" }}>{m.first_name?.[0]}{m.last_name?.[0]}</div>
              <span className="font-medium text-[#1C241B]">{m.first_name} {m.last_name}</span>
            </li>
          ))}
          {list.length === 0 && <li className="px-4 py-8 text-center text-sm text-[#7A8A78]">No one marked present yet.</li>}
        </ul>
        <DialogFooter className="gap-2 sm:justify-between">
          <Button variant="ghost" className="text-destructive" data-testid="attendees-delete-session" onClick={() => onDelete(session)}>
            <Trash2 className="h-4 w-4 mr-1" /> Delete session
          </Button>
          <Button data-testid="attendees-edit-button" onClick={() => onEdit(session)} className="bg-[#2D5A27] hover:bg-[#23471F] text-white">
            <Pencil className="h-4 w-4 mr-1" /> Edit attendance
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
